module.exports = __webpack_public_path__ + "static/media/coppenrath-wiese-1x.71a4a8fc.jpg";